import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./Login.module.css";
import { useAuth } from "../Context/Auth";
import toast from 'react-hot-toast';

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { loginUser, loading, error, success, isLoggedIn } = useAuth();
  const navigate = useNavigate();

  // ✅ التوجيه بعد تسجيل الدخول الفعلي فقط
  useEffect(() => {
    if (isLoggedIn && success) {
      console.log('✅ Login successful, redirecting...');
      toast.success(success);
      setTimeout(() => navigate("/", { replace: true }), 1000);
    }
  }, [isLoggedIn, success, navigate]);

  // ✅ عرض الخطأ لو وجد
  useEffect(() => {
    if (error) {
      console.log('❌ Login error:', error);
      toast.error(error);
    }
  }, [error]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Please fill in all fields!");
      return;
    }

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters!");
      return;
    }

    console.log('🚀 Attempting login with:', { email });
    const result = await loginUser({ email, password });

    if (result && result.Success) {
      console.log('✅ Login result received:', result);
    } else {
      console.log('❌ Login failed, no result');
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginBox}>
        <h2 className={styles.title}>Login</h2>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.inputGroup}>
            <label htmlFor="email" className={styles.label}>Email</label>
            <input
              type="email"
              id="email"
              className={styles.inputField}
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="password" className={styles.label}>Password</label>
            <input
              type="password"
              id="password"
              className={styles.inputField}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              disabled={loading}
            />
          </div>

          <Link to="/forgot-password" className={styles.forgotPassword}>
            Forgot your password?
          </Link>

          <button
            type="submit"
            className={styles.signInButton}
            disabled={loading}
          >
            {loading ? "Signing In..." : "SIGN IN"}
          </button>
        </form>

        <Link to="/register" className={styles.createAccount}>
          Create account
        </Link>

        <p className={styles.helpText}>Need help accessing your subscriptions?</p>

        <Link to="/help" className={styles.clickHere}>
          Click here
        </Link>
      </div>
    </div>
  );
};

export default Login;
